export const themes = {
  dark: "dark",
  light: "light",
} as const;

export type Theme = (typeof themes)[keyof typeof themes];

export const themeStorageKey = "genai-theme";
export const defaultTheme = themes.light;
